import editImg1 from "../../assets/editing/1.jpg";
import editImg2 from "../../assets/editing/2.jpg";
import editImg3 from "../../assets/editing/3.jpg";
import editImg4 from "../../assets/editing/4.jpg";
import editImg5 from "../../assets/editing/5.jpg";
import editImg6 from "../../assets/editing/6.jpg";
import editImg7 from "../../assets/editing/7.jpg";
import editImg8 from "../../assets/editing/8.jpg";
import editImg9 from "../../assets/editing/9.jpg";
import editImg10 from "../../assets/editing/10.jpg";
import editImg11 from "../../assets/editing/11.jpg";
import editImg12 from "../../assets/editing/12.jpg";
import editImg13 from "../../assets/editing/13.jpg";
import editImg14 from "../../assets/editing/14.jpg";

const editing: Video[] = [
  {
    title: "ABNY 50th Anniversary",
    video: "5uu359CTCb4",
    thumbnail: editImg1
  },
  {
    title: "Adam Kownacki Boxing",
    video: "LX2riuaaUlQ",
    thumbnail: editImg2
  },
  {
    title: "Dual Language | P.S. 34",
    video: "Bnojs3uxDcQ",
    thumbnail: editImg3
  },
  {
    title: "Dual Language | Claremont",
    video: "MYGR2_FVbNs",
    thumbnail: editImg4
  },
  {
    title: "Dual Language | New York",
    video: "M9oaDt3kxiI",
    thumbnail: editImg5
  },
  {
    title: "NY Emmy® Montage | 2013",
    video: "lk-7RBnVcA0",
    thumbnail: editImg6
  },
  {
    title: "NY Emmy® Montage | 2014",
    video: "PuCdHBd7Rfk",
    thumbnail: editImg7
  },
  {
    title: "NY Emmy® Montage | 2016",
    video: "7ut6DF78X0o",
    thumbnail: editImg8
  },
  {
    title: "NY Emmy® Montage | 2017",
    video: "du6MMOFH5i8",
    thumbnail: editImg9
  },
  {
    title: "NY Emmy® Montage | 2018",
    video: "bzOHhaGcYis",
    thumbnail: editImg10
  },
  {
    title: "NY Emmy® Montage | 2019",
    video: "k5i4wOD17Nw",
    thumbnail: editImg11
  },
  {
    title: "Gnawa Music",
    video: "gLs5kASPZkI",
    thumbnail: editImg12
  },
  {
    title: "Lessons in Leadership",
    video: "Awk9WVH2tTs",
    thumbnail: editImg13
  },
  {
    title: "Polish Heritage Night",
    video: "6NTlV4scXYc",
    thumbnail: editImg14
  }
]

export { editing };